export * from "modules/HoldingAppointmentDetails/hooks/useScrollToSectionMenus";
